import Component from '@glimmer/component';

import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import CButton from 'rise-ui/components/c-button.gjs';
import DropdownPrompt from 'rise-ui/components/dropdown-prompt.gjs';
import string from 'rise-ui/helpers/string.js';
import timeSeriesSelect from 'rise-ui/helpers/time-series-select.js';

export default class TimeSeriesSelectionActionsComponent extends Component {
  <template>
    <div class="c-actions">
      <CButton
        class="q-clear-dates"
        @activeDisabled={{true}}
        @activeTitle="Dates are Clear"
        @linkTo={{timeSeriesSelect clearDates=true}}
      >
        {{string "clear-all-dates"}}
      </CButton>
      {{#if false}}
        <DropdownPrompt
          @side="bottom-end"
          @disabled={{this.isClean}}
          @title={{if this.isClean "Query is Clear"}}
          @text="Save Query"
          @prompt="Name"
          @submitText={{if this.savedQueryOverwrite "Overwrite" (if this.savedQuery "Rename" "Save")}}
          @onResponse={{this.onSaveQueryResponse}}
          @onSubmit={{this.onSaveQuery}}
          @response={{this.savedQuery.name}}
          as | ddp |
        ><span {{didInsert this.setPrompt ddp}}></span></DropdownPrompt>
      {{/if}}
    </div>
  </template>
}
